import { useLeaderboardStore } from "../../store/leaderboardStore";
import { Leaderboard } from "./Leaderboard";
import { SeasonLeaderboard } from "./SeasonLeaderboard";

export const LeaderboardMain = () => {
  const { leaderboardLevel } = useLeaderboardStore();
  if (leaderboardLevel === "season") {
    return <SeasonLeaderboard />;
  }
  return <Leaderboard />;
};
